(function () {
  var loader = document.getElementById('canelita-loader');
  if (!loader) return;

  if (sessionStorage.getItem('canelita_visited')) {
    loader.remove();
    return;
  }

  var inner = loader.querySelector('.canelita-loader__inner');
  var hidden = false;

  function hide() {
    if (hidden) return;
    hidden = true;
    sessionStorage.setItem('canelita_visited', '1');

    // Giro del logo y persiana arrancan a la vez
    if (inner) inner.classList.add('canelita-loader--spin');
    loader.getBoundingClientRect(); // forzar reflow
    loader.classList.add('canelita-loader--out');

    loader.addEventListener('transitionend', function () {
      loader.remove();
    }, { once: true });
  }

  window.addEventListener('load', function () {
    setTimeout(hide, 1100);
  });

  // Failsafe
  setTimeout(hide, 4000);
})();

// Menú: evitar navegación en ítems agrupadores (href="#")
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('header-component a[href="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
    });
    a.style.cursor = 'default';
  });
});
